/**
 * Traçage des blocages silencieux du tunnel de commande.
 *
 * Contexte (incident du 16/09/2026) : les sorties de `validateShipping` et les
 * `catch` d'ajout au panier ne produisent aucun appel réseau — un client bloqué
 * est donc invisible côté serveur, et les erreurs partent dans GTM qui peut être
 * lui-même en panne. Ce plugin envoie un événement au serveur à chaque blocage,
 * ce qui le rend lisible dans Cloud Logging.
 *
 * Contraintes : ne jamais lever, ne jamais bloquer le tunnel, ne jamais
 * transmettre de donnée personnelle (on envoie des booléens de présence).
 */
export default (ctx, inject) => {
  const trace = (etape, detail = {}) => {
    try {
      const corps = JSON.stringify({
        etape,
        detail,
        chemin: typeof location !== 'undefined' ? location.pathname : null,
        ecran: typeof window !== 'undefined' ? window.innerWidth + 'x' + window.innerHeight : null,
        horodatage: new Date().toISOString()
      })

      // sendBeacon survit au déchargement de la page (client qui abandonne)
      if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon('/api/client-event', new Blob([corps], { type: 'application/json' }))
        return
      }

      fetch('/api/client-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: corps,
        keepalive: true
      }).catch(() => {})
    } catch (e) {
      // L'instrumentation ne doit jamais casser la vente.
    }
  }

  inject('trace', trace)
}
